import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
} from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import { useEffect } from 'react'

export default function MUITable({
    columns,
    rows,
    pagination,
    setPagination,
    listLength,
    onClickListRow,
    rowsPerPageOptions,
    handleChangePage,
    handleChangeRowsPerPage,
    mutipleSelect,
    selected,
    setSelected,
    stickyEditBtn = false
}) {
    const renderCell = (column, row) => {
        if (column.renderCell) {
            return column.renderCell({
                row,
                value: row[column.field],
            })
        }

        return row[column.field]
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
        const newSelected = rows.map((n, i) => rows[i]);
        setSelected(newSelected);
        return;
        }
        setSelected([]);
    };

    const handleClick = (row) => {
        const selectedIndex = selected.findIndex((item) => item.id === row.id);
        let newSelected = [];

        if (selectedIndex === -1) {
        newSelected = [...selected, row];
        } else {
        newSelected = selected.filter((item) => item.id !== row.id);
        }

        setSelected(newSelected);
    };

    const isSelected = (row) => selected.findIndex((item) => item.id === row.id) !== -1;

    // const onChangePage = (e, newPage) => {
    //     setPagination({ ...pagination, page: newPage })
    // }

    // const onChangePageSize = (e) => {
    //     setPagination({ ...pagination, pageSize: e.target.value })
    // }

    useEffect(() => {
        const maxPage = Math.ceil(listLength / pagination.pageSize) - 1

        if (pagination.page > maxPage && maxPage >= 0) {
            setPagination((pre) => ({
                ...pre,
                page: 0,
            }))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listLength, pagination.pageSize])

    return (
        <TableContainer component={Paper} sx={{ height: '100%' }}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {(selected && setSelected) && (
                            <TableCell
                                sx={{
                                    width: 50,
                                    flex: 1,
                                    fontWeight: 700,
                                    backgroundColor: '#eee',
                                }}
                                component='th'>
                                    <Checkbox 
                                        onChange={(e) => {handleSelectAllClick(e)}}
                                        indeterminate={selected.length > 0 && selected.length < rows.length}
                                        // color="primary"
                                        checked={rows.length > 0 && selected.length === rows.length} 
                                    />
                            </TableCell>
                        )}
                        {columns.map((column, columnIdx) => (
                            <TableCell
                                className={column.field === 'actions' && stickyEditBtn ? 'edit-btn-sticky' : ''}
                                key={columnIdx}
                                sx={{
                                    width: column.width,
                                    flex: column.flex || 1,
                                    fontWeight: 700,
                                    backgroundColor: '#eee',
                                }}
                                component='th'
                            >
                                {column.headerName}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, rowIdx) => {
                        let isItemSelected = false;
                        if (selected && setSelected) {
                         isItemSelected = isSelected(row);
                        }
                        return (
                        <TableRow
                            key={`row-${row.id}`}
                            onClick={onClickListRow ? () => onClickListRow(row) : () => {}}
                            sx={
                                onClickListRow
                                    ? {
                                          cursor: 'pointer',
                                          '&:hover': {
                                              backgroundColor: 'rgba(0, 0, 0, 0.04)',
                                          },
                                      }
                                    : {}
                            }
                        >
                            {(selected && setSelected) && (
                                <TableCell sx={{ width: 50, flex: 1 }} component='td'>
                                    <Checkbox onClick={(event) => {handleClick(row); event.stopPropagation()}}
                                        color="primary"
                                        checked={isItemSelected} />
                                </TableCell>
                            )}
                            {columns.map((column, columnIdx) => (
                                <TableCell
                                    className={column.field === 'actions' && stickyEditBtn ? 'edit-btn-sticky' : ''}
                                    key={`cell-${columnIdx}-${rowIdx}`}
                                    sx={{ width: column.width, flex: column.flex || 1, backgroundColor: column.field === 'actions' ? '#e5e5e5' : '', width: 0, whiteSpace: 'wrap' } }
                                    component='td'
                                >
                                    {renderCell(column, row)}
                                </TableCell>
                            ))}
                        </TableRow>
                    )})}
                </TableBody>
            </Table>
            <TablePagination
                component='div'
                count={parseInt(listLength)}
                page={pagination.page}
                onPageChange={handleChangePage}
                rowsPerPage={pagination.pageSize}
                rowsPerPageOptions={rowsPerPageOptions ? rowsPerPageOptions : [10, 25, 50, 100]}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{ position: 'sticky', bottom: 0, backgroundColor: '#fff' }}
            />
        </TableContainer>
    )
}
